module.exports = __webpack_public_path__ + "img/add_scenario_rouge.29db4a7a.svg";